<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection>
            <template #title>
                User Information
            </template>

            <div class="row">
                <div class="col-full lg:col-1/2">
                    <FormGroup
                        name="firstname"
                        label="First Name">
                        <Input
                            ref="firstname"
                            v-model="form.firstname"
                            name="firstname"
                            placeholder="Please enter the firstname..."
                            autofocus/>
                    </FormGroup>
                </div>
                <div class="col-full lg:col-1/2">
                    <FormGroup
                        name="lastname"
                        label="Last Name">
                        <Input
                            v-model="form.lastname"
                            name="lastname"
                            placeholder="Please enter the lastname..."/>
                    </FormGroup>
                </div>
            </div>

            <FormGroup
                name="email"
                label="Email">
                <Input
                    v-model="form.email"
                    name="email"
                    type="email"
                    placeholder="Please enter an email address..."/>
            </FormGroup>

            <FormGroup
                name="phone"
                label="Phone">
                <Input
                    v-model="form.phone"
                    name="phone"
                    placeholder="Please enter a phone number..."/>
            </FormGroup>

            <FormGroup
                name="profile_image_id"
                label="Profile Image">
                <File
                    v-model="form.profile_image_id"
                    :file="profileImage"
                    :image="true"
                    accept="image/jpeg,image/png"/>
            </FormGroup>
        </FormSection>

        <FormSection v-if="roles">
            <template #title>
                User Roles
            </template>

            <Label :class="{'text-red-500': form.hasError('role_ids')}">
                Roles
            </Label>
            <InputError class="mt-1" :message="form.getError('role_ids')"/>
            <ul class="space-y-2 mt-4">
                <li>
                    <FormGroup
                        v-for="(role, i) in roles"
                        :name="`role_ids.${i}`"
                        :label="role.label"
                        inline>
                        <Checkbox
                            v-model="form.role_ids"
                            :value="role.value"/>
                    </FormGroup>
                </li>
            </ul>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";
import File from "@/Components/Form/File.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Label from "@/Components/Form/Label.vue";
import Checkbox from "@/Components/Form/Checkbox.vue";
import {optionsToArray} from "@/Lib/Helpers";
import axios from "axios";

export default {

    name: "UserForm",

    props: {
        profileImage: {
            type: Object,
            default: () => ({})
        }
    },

    emits: ['submit'],

    data() {
        return {
            loaded: false,
            roles: [],
        };
    },

    inject: ['form'],

    async created() {
        await this.fetchRoles();
        this.loaded = true;
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.firstname.mainElement().focus();
        });
    },

    components: {
        FormSection,
        FormGroup,
        Input,
        File,
        Textarea,
        Label,
        InputError,
        Checkbox
    },

    methods: {
        async fetchRoles() {
            this.roles = optionsToArray((await axios.get(route('api.roles.index'))).data, false);
        }
    },
};

</script>
